<template>
    <div class="field is-horizontal">
        <div class="field-label is-normal">
            <label class="label">Odometer Fix</label>
        </div>
        <div class="field-body">
            <div class="field">
                <div class="control has-icons-left">
                    <input class="input" type="text" v-model="odometer_fix" placeholder="Odometer fix" :class="{ 'is-danger': errors.odometer_fix }">
                    <span class="icon is-left">
                       <i class="fas fa-wrench"></i>
                    </span>
                    <p v-if="errors.odometer_fix" class="help is-danger">{{ errors.odometer_fix[0] }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {

            }
        },
        computed: {
            odometer_fix: {
                get() {
                    return this.$store.getters.getNewPricePlan.odometer_fix
                },
                set(value) {
                    this.$store.dispatch('setNewPricePlanFieldValue', {field: 'odometer_fix', value: value})
                }
            },
            errors() {
                return this.$store.getters.getNewPricePlanErrors
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/ControlPanel/PricePlans/NewPlan/Inputs/OdometerFixInput.vue